import React, { useEffect, useMemo, useState } from "react";
import './Proyectos.scss'
import Filtros from "./partes/Filtros/Filtros";
import TableView from "./partes/TableView/TableView";
import KanvanViwew from "./partes/KanvanViwew/KanvanViwew";
import GantView from "./partes/GantView/GantView";
import { IntegracionProyectos } from "./integracion";


const Proyectos = () => {
    const [view, setView] = useState('kanvan');
    const [dataBase, setDataBase] = useState({
        area: [],
        proyecto: [],
        sprint: [],
        tarea: [],
        usuario: [],
        prioridades: [],
        estatus: [],
        sprints: [],
        tareas: []
    })
    const [vista, setVista] = useState('kanban')
    const getFecha30DiasAtras = () => {
        const fecha = new Date();
        fecha.setDate(fecha.getDate() - 30);
        const yyyy = fecha.getFullYear();
        const mm = String(fecha.getMonth() + 1).padStart(2, '0');
        const dd = String(fecha.getDate()).padStart(2, '0');

        const fecha30DiasAtras = `${yyyy}-${mm}-${dd}`;
        const fechaHoy = new Date();
        const yyyyHoy = fechaHoy.getFullYear();
        const mmHoy = String(fechaHoy.getMonth() + 1).padStart(2, '0');
        const ddHoy = String(fechaHoy.getDate()).padStart(2, '0');
        const fechaHoyStr = `${yyyyHoy}-${mmHoy}-${ddHoy}`;

        return { fechaIni: fecha30DiasAtras, fechaFin: fechaHoyStr };
    }

    const rangoFechasInicial = getFecha30DiasAtras();

    const [filtros, setFiltros] = useState({
        estatus: [],
        prioridades: [],
        areas: [],
        proyectos: [],
        sprints: [],
        usuarios: [],
        fechaIni: rangoFechasInicial.fechaIni,
        fechaFin: rangoFechasInicial.fechaFin
    }
    )
    // funcion para obtener la fecha de hoy a hace 30 dias atras en formato yyyy-mm-dd y la fecha de hoy en formato yyyy-mm-dd

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        // Fetch data from API or perform any necessary operations
        await IntegracionProyectos.getAreas().then((res) => {
            setDataBase((prevData) => ({
                ...prevData,
                area: res
            }));
        })
        await IntegracionProyectos.getProyectos().then((res) => {
            setDataBase((prevData) => ({
                ...prevData,
                proyecto: res
            }));
        })
        await IntegracionProyectos.getPrioridades().then((res) => {
            setDataBase((prevData) => ({
                ...prevData,
                prioridades: res
            }));
        })
        await IntegracionProyectos.getSprint().then((res) => {
            setDataBase((prevData) => ({
                ...prevData,
                sprints: res
            }));
        })
        await IntegracionProyectos.getTareas().then((res) => {
            setDataBase((prevData) => ({
                ...prevData,
                tareas: res
            }));
        })

        // INPUTS
        await IntegracionProyectos.getUsuario().then((res) => {
            setDataBase((prevData) => ({
                ...prevData,
                usuario: res
            }));
        })
        await IntegracionProyectos.getStatus().then((res) => {
            setDataBase((prevData) => ({
                ...prevData,
                estatus: res
            }));
        })

    }
    const getId = (item) => item?.ID ?? item?.value;

    const parseDateValue = (value) => {
        if (!value) return null;

        const asString = String(value).trim();
        if (!asString) return null;

        // Soporta "yyyy-mm-dd hh:mm:ss", "yyyy-mm-dd" y formatos ISO
        const normalized = asString.includes(' ') ? asString.replace(' ', 'T') : asString;
        const parsed = new Date(normalized);

        if (Number.isNaN(parsed.getTime())) {
            return null;
        }

        return parsed;
    };

    const normalizeStatus = (status) =>
        String(status || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toUpperCase();

    const tareasFiltradas = useMemo(() => {
        const selectedEstatusIds = filtros.estatus.map(getId);
        const selectedPrioridadIds = filtros.prioridades.map(getId);
        const selectedAreaIds = filtros.areas.map(getId);
        const selectedProyectoIds = filtros.proyectos.map(getId);
        const selectedSprintIds = filtros.sprints.map(getId);
        const selectedUsuarioIds = (filtros.usuarios || []).map(getId);
        const fechaInicio = parseDateValue(filtros.fechaIni);
        const fechaFin = parseDateValue(filtros.fechaFin);

        if (fechaInicio) {
            fechaInicio.setHours(0, 0, 0, 0);
        }

        if (fechaFin) {
            fechaFin.setHours(23, 59, 59, 999);
        }

        const proyectoToArea = new Map(
            (dataBase.proyecto || []).map((proy) => [proy.ID, proy.ID_AREA])
        );

        const estatusById = new Map(
            (dataBase.estatus || []).map((item) => [item.ID, item.ESTATUS])
        );

        return (dataBase.tareas || []).filter((tarea) => {
            const areaIdFromProject = proyectoToArea.get(tarea.PROYECTO_ID);
            const areaIdTarea = tarea.AREA_ID ?? areaIdFromProject;
            const estatusNombre = tarea.ESTATUS ?? estatusById.get(tarea.ESTATUS_ID);
            const estatusNormalizado = normalizeStatus(estatusNombre);
            const esTerminadoOCancelado =
                estatusNormalizado.includes('TERMIN') ||
                estatusNormalizado.includes('CANCEL');
            const fechaTarea = parseDateValue(tarea.FECHA_FIN ?? tarea.FECHA_INI);

            const matchEstatus = selectedEstatusIds.length === 0 || selectedEstatusIds.includes(tarea.ESTATUS_ID);
            const matchPrioridad = selectedPrioridadIds.length === 0 || selectedPrioridadIds.includes(tarea.PRIORIDAD_ID);
            const matchProyecto =
                selectedProyectoIds.length === 0 ||
                (tarea.PROYECTO_ID == null || selectedProyectoIds.includes(tarea.PROYECTO_ID));
            const matchSprint =
                selectedSprintIds.length === 0 ||
                (tarea.SPRINT_ID == null || selectedSprintIds.includes(tarea.SPRINT_ID));
            const matchArea =
                selectedAreaIds.length === 0 ||
                (areaIdTarea == null || selectedAreaIds.includes(areaIdTarea));
            const matchUsuario =
                selectedUsuarioIds.length === 0 ||
                (tarea.USUARIO_ASIGNADO_ID == null || selectedUsuarioIds.includes(tarea.USUARIO_ASIGNADO_ID));
            const matchFecha =
                !fechaInicio ||
                !fechaFin ||
                !esTerminadoOCancelado ||
                (fechaTarea != null && fechaTarea >= fechaInicio && fechaTarea <= fechaFin);

            return (
                matchEstatus &&
                matchPrioridad &&
                matchProyecto &&
                matchSprint &&
                matchArea &&
                matchUsuario &&
                matchFecha
            );
        });
    }, [
        dataBase.tareas,
        dataBase.proyecto,
        dataBase.estatus,
        filtros.estatus,
        filtros.prioridades,
        filtros.areas,
        filtros.proyectos,
        filtros.sprints,
        filtros.usuarios,
        filtros.fechaIni,
        filtros.fechaFin,
    ]);

    const dataFiltrada = useMemo(() => ({
        ...dataBase,
        tareas: tareasFiltradas,
    }), [dataBase, tareasFiltradas]);

    return (
        <div className="Proyectos">
            <Filtros vista={vista} setVista={setVista} setData={setDataBase} data={dataBase} filtros={filtros} setFiltros={setFiltros}></Filtros>
            {
                vista === 'tabla' && <TableView setData={setDataBase} data={dataFiltrada}></TableView>
            }
            {
                vista === 'kanban' && <KanvanViwew setData={setDataBase} data={dataFiltrada} filtros={filtros} setFiltros={setFiltros}></KanvanViwew>
            }
            {
                vista === 'gantt' && <GantView data={dataFiltrada} setData={setDataBase}></GantView>
            }
        </div>
    )
}
export default Proyectos